import { IPagination } from "@interfaces";
import axiosClient from "./axiosClient";
import axiosGo from "./axiosGo";

export const historyApi = {
    getListHistory: (params: IPagination) => {
        const url = "/histories/all";
        return axiosClient.get(url, { params });
    },
    getListHistoryDetailById: (id: string) => {
        const url = `/histories/${id}/history`;
        return axiosClient.get(url);
    },

    getHistoryPublic: (id: string, params: { merchantId: string }) => {
        const config = {
            headers: {
                "merchant-id": params.merchantId,
            },
        };
        const url = "histories/public/" + id;
        return axiosClient.get(url, config);
    },
    getClientHistoryPoint: (id: string, params: { limit: number; page: number }) => {
        const url = `/users/getClientHistoryPointByUserId/${id}`;
        return axiosClient.get(url, { params });
    },
    getReceiptUpload: (id: string) => {
        const url = `/approvereceipt/receipt/${id}`;
        return axiosClient.get(url);
    },
    gethistories: (param?: string) => {
        const url = "/histories/client-all" + `/${param}`;
        return axiosClient.get(url);
    },
    getPointHistoryFromGo: (params: any) => {
        const url = "/point/api/v1/points/transactions";
        return axiosGo.get(url, { params });
    },
    getUploadHistoryFromGo: (params: any) => {
        const url = "/receipt/api/v1/receipt-upload-transactions";
        return axiosGo.get(url, { params });
    },
};
